import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const Login = () => import('@/views/login/index')
/* Layout */
import Layout from '@/layout'
export const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  //数据大屏
  {
    path: '/',
    redirect: '/gardenList',
    hidden: true
  },

  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: '/gardenList',
        name: 'gardenList',
        component: () => import('@/views/order/orderList.vue'),
        meta: { title: '订单列表', icon: 'rz-icon rz-icon-gardens' }
      },

    ]
  },



  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
  {path: '/print_list', hidden: true, component: () => import('@/views/order/print_list')},
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
